import React from "react";
import { Link } from "react-router-dom";

export const buildUnitColumns = ({ isAdmin, onDeleteRequest }) => [
  { header: "Unit Type", accessorKey: "unit_type", enableColumnFilter: false },
  { header: "Apartment Type", accessorKey: "apt_type", enableColumnFilter: false },
  { header: "CF", accessorKey: "cf", enableColumnFilter: false },
  { header: "Number", accessorKey: "nr", enableColumnFilter: false },
  { header: "initial_price", accessorKey: "initial_price", enableColumnFilter: false },
  { header: "Settled Price", accessorKey: "settled_price", enableColumnFilter: false },
  {
    header: "Floor",
    accessorKey: "floor",
    enableColumnFilter: false,
    cell: (cell) => {
      const floor = cell.getValue();
      const rowClass = floor % 2 === 0 ? "even-floor" : "odd-floor";
      return <div className={rowClass}>{floor}</div>;
    },
  },
  { header: "Number OF Rooms", accessorKey: "num_rooms", enableColumnFilter: false },
  {
    header: "Action",
    cell: (cellProps) => (
      <ul className="list-inline hstack gap-2 mb-0">
        <li className="list-inline-item">
          <Link
            to={`/unit-details/${cellProps.row.original.id}`}
            className="text-primary d-inline-block"
          >
            <i className="ri-eye-fill fs-16"></i>
          </Link>
        </li>
        {isAdmin && (
          <li className="list-inline-item">
            <Link
              to="#"
              className="text-danger d-inline-block remove-item-btn"
              onClick={() => onDeleteRequest(cellProps.row.original)}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i>
            </Link>
          </li>
        )}
      </ul>
    ),
  },
];
